import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/103a8db92c2304d2cec6f101555401a3.jpeg"
          alt="おかやま就労支援事業所の明るい雰囲気"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white space-y-6 lg:space-y-8">
            {/* Trust Badge */}
            <div className="inline-block">
              <span className="bg-primary-light/90 text-white px-4 py-2 rounded-full text-xs sm:text-sm font-medium">
                岡山市認可事業所
              </span>
            </div>

            {/* Main Heading */}
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              あなたらしく、<br />働く未来へ
            </h1>
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold">
              岡山で寄り添う<strong>就労支援</strong>
            </h2>

            {/* Description */}
            <p className="text-base sm:text-lg lg:text-xl text-white/90 leading-relaxed max-w-xl">
              <strong>障害や病気</strong>があっても、自分のペースで<strong>働きたい</strong>あなたを全力でサポートします。一人ひとりの可能性を信じ、共に歩む<strong>就労支援</strong>を提供しています。
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-3 max-w-md">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-full font-medium text-sm hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2 text-base"></i>
                見学・お問い合わせはこちら
              </Link>
              <a
                href="tel:0860123456"
                className="inline-flex items-center justify-center px-6 py-3 bg-white text-primary rounded-full font-medium text-sm hover:bg-white/90 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2 text-base"></i>
                086-012-3456
              </a>
            </div>
          </div>

          {/* Right Info Card - Removed */}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
